import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { Box, Typography } from "@mui/material";

type ChatUserMessageProps = {
  content: string;
};

export function ChatUserMessage({ content }: ChatUserMessageProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1,
        width: "100%",
      }}
    >
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Box
          sx={{
            borderRadius: 2,
            px: 2,
            py: 1.25,
            maxWidth: "72%",
            bgcolor: "var(--theme-primary)",
            color: "var(--theme-text-on-primary)",
          }}
        >
          <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
            {content}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          width: 28,
          height: 28,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "var(--theme-surface-hover)",
          color: "var(--theme-text-secondary)",
          flexShrink: 0,
        }}
        aria-hidden
      >
        <PersonOutlineIcon sx={{ fontSize: 18 }} />
      </Box>
    </Box>
  );
}
